import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { catchError, map, of } from "rxjs";
import { MaintenanceApiService } from "./maintenance-api.service";

export function maintenanceGuard(applicationId: string, { redirectTo }: { redirectTo?: unknown[] } = {}): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const maintenance = inject(MaintenanceApiService);
        const router = inject(Router);
        const { skipMaintenanceCheck } = route.queryParams;

        if (skipMaintenanceCheck && skipMaintenanceCheck === "1") {
            return true;
        }

        return maintenance.getMaintenanceMode(applicationId).pipe(
            map((maintenanceMode) => {
                if (maintenanceMode !== null && maintenanceMode.maintenance) {
                    router.navigate(redirectTo ?? ["app", "maintenance"], { state: { message: maintenanceMode.message } });
                    return false;
                } else {
                    return true;
                }
            }),
            catchError(() => of(true))
        );
    };
}
